/**
 * Builds a compact summary of H2K export validation errors for Sentry context.
 * Mirrors the Critical / Warnings split shown in the Review ErrorList UI.
 */
export const summarizeExportErrors = (errors = []) => {
    const normalized = (Array.isArray(errors) ? errors : []).map(
        ({ fieldId, dataType, message, warningLevel }) => ({
            fieldId,
            dataType,
            message,
            warningLevel,
        })
    );

    const criticalCount = normalized.filter(({ warningLevel }) => warningLevel === "critical").length;
    const warningCount = normalized.filter(({ warningLevel }) => warningLevel === "warning").length;

    return {
        totalCount: normalized.length,
        criticalCount,
        warningCount,
        errors: normalized,
    };
};
